// Products data for Navaris Digital

export const productCategories = [
  {
    id: 1,
    name: "Mobile Apps",
    slug: "mobile-apps",
    description: "Enterprise-grade mobile applications for iOS and Android platforms",
    icon: "Smartphone",
    image: "https://images.unsplash.com/photo-1674027444485-cec3da58eef4",
    products: [
      {
        id: 1,
        name: "MobiPay - Digital Wallet",
        description: "Secure digital wallet solution with multi-currency support, QR payments, and blockchain integration",
        features: [
          "Multi-currency wallet",
          "QR code payments",
          "Blockchain integration",
          "Biometric security",
          "Transaction history & analytics"
        ],
        technologies: ["React Native", "Node.js", "MongoDB", "Blockchain"],
        image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3"
      },
      {
        id: 2,
        name: "HealthTrack Pro",
        description: "Comprehensive health and fitness tracking app with AI-powered insights",
        features: [
          "Activity tracking",
          "Nutrition management",
          "AI health insights",
          "Wearable device integration",
          "Telemedicine support"
        ],
        technologies: ["Flutter", "Python", "TensorFlow", "Firebase"],
        image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d"
      },
      {
        id: 3,
        name: "EduLearn Platform",
        description: "Interactive learning platform with live classes, assessments, and progress tracking",
        features: [
          "Live video classes",
          "Interactive quizzes",
          "Progress analytics",
          "Gamified learning",
          "Offline content access"
        ],
        technologies: ["React Native", "WebRTC", "AWS", "GraphQL"],
        image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b"
      }
    ]
  },
  {
    id: 2,
    name: "Games",
    slug: "games",
    description: "Engaging mobile and web games with stunning graphics and immersive gameplay",
    icon: "Gamepad2",
    image: "https://images.unsplash.com/photo-1511512578047-dfb367046420",
    products: [
      {
        id: 4,
        name: "Battle Royale Arena",
        description: "Fast-paced multiplayer battle royale game with stunning 3D graphics",
        features: [
          "100-player matches",
          "Real-time multiplayer",
          "Customizable characters",
          "Seasonal events",
          "Cross-platform play"
        ],
        technologies: ["Unity", "Photon", "C#", "AWS GameLift"],
        image: "https://images.unsplash.com/photo-1538481199705-c710c4e965fc"
      },
      {
        id: 5,
        name: "Puzzle Quest",
        description: "Addictive puzzle game with thousands of levels and daily challenges",
        features: [
          "5000+ levels",
          "Daily challenges",
          "Power-ups & boosters",
          "Social features",
          "Offline play support"
        ],
        technologies: ["Unity", "C#", "Firebase", "PlayFab"],
        image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f"
      }
    ]
  },
  {
    id: 3,
    name: "Utility Apps",
    slug: "utility-apps",
    description: "Productivity tools and utilities that simplify everyday tasks",
    icon: "Wrench",
    image: "https://images.pexels.com/photos/2085831/pexels-photo-2085831.jpeg",
    products: [
      {
        id: 6,
        name: "TaskMaster Pro",
        description: "Advanced task management and productivity suite for teams and individuals",
        features: [
          "Task & project management",
          "Team collaboration",
          "Time tracking",
          "Calendar integration",
          "Custom workflows"
        ],
        technologies: ["React", "Node.js", "PostgreSQL", "Redis"],
        image: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b"
      },
      {
        id: 7,
        name: "DocuScan AI",
        description: "AI-powered document scanner with OCR and smart organization",
        features: [
          "AI-powered OCR",
          "Multi-format export",
          "Cloud sync",
          "Document organization",
          "Batch processing"
        ],
        technologies: ["React Native", "TensorFlow", "Python", "AWS S3"],
        image: "https://images.unsplash.com/photo-1586281380349-632531db7ed4"
      },
      {
        id: 8,
        name: "SmartBudget",
        description: "Personal finance management app with AI-powered insights",
        features: [
          "Expense tracking",
          "Budget planning",
          "Investment tracking",
          "AI financial insights",
          "Bill reminders"
        ],
        technologies: ["Flutter", "Python", "Machine Learning", "Plaid API"],
        image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c"
      }
    ]
  },
  {
    id: 4,
    name: "AI Solutions",
    slug: "ai-solutions",
    description: "Cutting-edge artificial intelligence solutions for business automation",
    icon: "Brain",
    image: "https://images.unsplash.com/photo-1697577418970-95d99b5a55cf",
    products: [
      {
        id: 9,
        name: "ChatBot Pro",
        description: "Advanced AI chatbot platform with natural language understanding",
        features: [
          "Multi-language support",
          "Intent recognition",
          "Contextual conversations",
          "CRM integration",
          "Analytics dashboard"
        ],
        technologies: ["Python", "GPT-4", "FastAPI", "MongoDB"],
        image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a"
      },
      {
        id: 10,
        name: "Vision AI Suite",
        description: "Computer vision platform for image and video analysis",
        features: [
          "Object detection",
          "Facial recognition",
          "Video analytics",
          "Custom model training",
          "Real-time processing"
        ],
        technologies: ["Python", "TensorFlow", "OpenCV", "CUDA"],
        image: "https://images.unsplash.com/photo-1555255707-c07966088b7b"
      },
      {
        id: 11,
        name: "Predictive Analytics Engine",
        description: "Machine learning platform for business forecasting and insights",
        features: [
          "Time series forecasting",
          "Anomaly detection",
          "Customer churn prediction",
          "Demand forecasting",
          "Custom ML models"
        ],
        technologies: ["Python", "Scikit-learn", "Apache Spark", "Tableau"],
        image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71"
      }
    ]
  },
  {
    id: 5,
    name: "Enterprise Solutions",
    slug: "enterprise-solutions",
    description: "Scalable enterprise software for large organizations",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
    products: [
      {
        id: 12,
        name: "HRM Pro",
        description: "Comprehensive human resource management system",
        features: [
          "Employee management",
          "Payroll processing",
          "Performance tracking",
          "Recruitment pipeline",
          "Self-service portal"
        ],
        technologies: ["React", "Java Spring Boot", "Oracle", "Kafka"],
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978"
      },
      {
        id: 13,
        name: "Supply Chain Manager",
        description: "End-to-end supply chain visibility and optimization platform",
        features: [
          "Inventory management",
          "Logistics tracking",
          "Supplier management",
          "Demand planning",
          "Real-time analytics"
        ],
        technologies: ["Angular", ".NET Core", "SQL Server", "Azure"],
        image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d"
      }
    ]
  },
  {
    id: 6,
    name: "IoT Solutions",
    slug: "iot-solutions",
    description: "Connected device solutions for smart homes and industries",
    icon: "Cpu",
    image: "https://images.unsplash.com/photo-1558346490-a72e53ae2d4f",
    products: [
      {
        id: 14,
        name: "SmartHome Hub",
        description: "Central control system for smart home devices",
        features: [
          "Device management",
          "Automation rules",
          "Voice control",
          "Energy monitoring",
          "Security alerts"
        ],
        technologies: ["React Native", "MQTT", "Node.js", "InfluxDB"],
        image: "https://images.unsplash.com/photo-1558002038-1055907df827"
      },
      {
        id: 15,
        name: "Industrial IoT Platform",
        description: "Industrial IoT monitoring and predictive maintenance system",
        features: [
          "Real-time monitoring",
          "Predictive maintenance",
          "Asset tracking",
          "Alert management",
          "Historical analytics"
        ],
        technologies: ["Python", "MQTT", "TimescaleDB", "Grafana"],
        image: "https://images.unsplash.com/photo-1581092160607-ee67df219b0f"
      }
    ]
  }
];
